const assetData = [
    {
        "id": 1,
        "name": "A Letter",
        "description": "This is asset 1",
        "Quantity": 1,
    },
    {
        "id": 2,
        "name": "Podium 1(Mockup)",
        "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore, recusandae.",
        "Quantity": 1,
    },
    {
        "id": 3,
        "name": "Podium 2(Mockup)",
        "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore, recusandae.",
        "Quantity": 1,
    },
    {
        "id": 4,
        "name": "Demo Stand",
        "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore, recusandae.",
        "Quantity": 1,
    },
    {
        "id": 5,
        "name": "55 inch Touch Screen",
        "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore, recusandae.",
        "Quantity": 1,
    },
    {
        "id": 6,
        "name": "Custom Sofa(1000 X 1000)",
        "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore, recusandae.",
        "Quantity": 1,
    },
    {
        "id": 7,
        "name": "Custom Sofa(500 X 500)",
        "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore, recusandae.",
        "Quantity": 1,
    },
    {
        "id": 8,
        "name": "Catering Station",
        "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore, recusandae.",
        "Quantity": 1,
    },
    {
        "id": 9,
        "name": "Meeting Room Table",
        "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore, recusandae.",
        "Quantity": 1,
    },
    {
        "id": 10,
        "name": "Meeting Room Cabinet",
        "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore, recusandae.",
        "Quantity": 1,
    },

    {
        "id": 11,
        "name": "Reception(1000 X 500)",
        "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore, recusandae.",
        "Quantity": 1,
    },

    {
        "id": 12,
        "name": "Reception(1500 X 500)",
        "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore, recusandae.",
        "Quantity": 1,
    },
    {
        "id": 13,
        "name": "Podium (Blue Edge)",
        "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore, recusandae.",
        "Quantity": 1,
    },
    {
        "id": 14,
        "name": "Mockup Info Stand",
        "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore, recusandae.",
        "Quantity": 1,
    },
]

export default assetData;
